import React from 'react';
import { Dialog, SxProps } from '@mui/material';

/** Styles for Dialog's component. */
const getDialogSx = (customSx?: SxProps): SxProps => ({
    '& .MuiDialog-paper': {
        height: '80%',
        minWidth: '350px',
        maxHeight: '560px',
        maxWidth: '560px',
        padding: 0,
        ...customSx,
    },
});

export default ({ open, children, customSx }: IDialogFrameProps) => {
    return (
        <Dialog open={open} sx={getDialogSx(customSx)}>
            {children}
        </Dialog>
    );
};

export interface IDialogFrameProps extends React.PropsWithChildren {
    open: boolean;
    customSx?: SxProps;
}
